import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { AppContext } from "../../../../context/AppContext";
import CashierModal from "../../../Modals/CashierModals/CashierModal";
import SearchModal from "../../../Modals/SearchModal/SearchModal";
import { StyledMobileNavBar } from "./styles";
import { ReactComponent as SearchIcon } from "../../../../assets/images/navbar-search-icon.svg";
import {
  requestAuthentication,
  useAuth,
} from "@/context/AuthContext";

const MenuIcon = () => (
  <svg className="line-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M4 7h16M4 12h16M4 17h16" />
  </svg>
);

const SupportIcon = () => (
  <svg className="line-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M4 13a8 8 0 0 1 16 0v4a2 2 0 0 1-2 2h-2" />
    <path d="M6 13H5a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1v-5Z" />
    <path d="M18 13h1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-1v-5Z" />
    <path d="M12 19h4" />
  </svg>
);

const HomeIcon = () => (
  <svg className="line-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="m3.5 11 8.5-7 8.5 7" />
    <path d="M5.5 10.5V20h13v-9.5" />
    <path d="M10 20v-6h4v6" />
  </svg>
);

const MobileNavBar = () => {
  const {
    updateSidebar,
  } = useContext(AppContext);

  const { user } = useAuth();
  const location = useLocation();
  const isSupportActive = location.pathname.startsWith("/customer-service-center");
  const isHomeActive = location.pathname === "/";
  const isAuthenticated = Boolean(user?.isAuthenticated);

  const closeSidebar = () => updateSidebar(false);
  const toggleSidebar = () => updateSidebar((prev) => !prev);
  const requireAuthentication = (event, reason) => {
    if (isAuthenticated) return false;

    event?.preventDefault();
    closeSidebar();
    if (!user?.isLoading) requestAuthentication(reason);
    return true;
  };

  return (
    <StyledMobileNavBar>
      <div className="buttons-container">
        <button className="button mobile-nav-action" onClick={toggleSidebar} aria-label="메뉴">
          <MenuIcon />
        </button>

        <Link
          className={`button mobile-nav-action ${isSupportActive ? "is-active" : ""}`}
          to="/customer-service-center"
          aria-label="고객문의"
          onClick={(event) => {
            if (!requireAuthentication(event, "mobile-support")) closeSidebar();
          }}
        >
          <SupportIcon />
        </Link>

        <Link
          className={`button mobile-nav-home ${isHomeActive ? "is-active" : ""}`}
          to="/"
          aria-label="홈"
          onClick={closeSidebar}
        >
          <HomeIcon />
        </Link>

        {isAuthenticated ? (
          <SearchModal triggerClassName="button mobile-nav-action" triggerAriaLabel="검색" />
        ) : (
          <button
            type="button"
            className="button mobile-nav-action"
            aria-label="검색"
            onClick={(event) => requireAuthentication(event, "mobile-search")}
          >
            <SearchIcon />
          </button>
        )}

        {user?.profile ? (
          <CashierModal button="지갑" />
        ) : (
          <span className="button mobile-nav-placeholder" aria-hidden="true" />
        )}
      </div>
    </StyledMobileNavBar>
  );
};

export default MobileNavBar;
